export var LANGUAGES_META = {
    ru: {
        title: 'Русский',
    },
    en: {
        title: 'English',
    },
};
export var getFormattedLanguages = function (pureLanguages) {
    return pureLanguages
        ? pureLanguages.map(function (language) { return ({
            id: language,
            value: LANGUAGES_META[language]
                ? LANGUAGES_META[language].title
                : language,
        }); })
        : [];
};
